import http from '../httpConfig';
import { API_ENDPOINTS } from '../utils/apiConstant';

export interface AuditLogFilter {
  startDate?: string;
  endDate?: string;
  actorId?: number;
  entityType?: string[];
  actionType?: string[];
  tenantId?: number;
  search?: string;
  page?: number;
  limit?: number;
}

export interface AuditLogEntry {
  id: number;
  actor_id: number | null;
  actor_full_name: string | null;
  action_type: string;
  action_description: string;
  meta: Record<string, unknown> | null;
  created_at: string;
  actor_name_snapshot: string | null;
  actor_role_snapshot: string | null;
  entity_type: string | null;
  entity_id: string | null;
  entity_name_snapshot: string | null;
  old_value: Record<string, unknown> | null;
  new_value: Record<string, unknown> | null;
  reason: string | null;
  ip_address: string | null;
}

const buildQuery = (filter: AuditLogFilter) => {
  const params: Record<string, string> = {};
  if (filter.startDate) params.startDate = filter.startDate;
  if (filter.endDate) params.endDate = filter.endDate;
  if (filter.actorId) params.actorId = String(filter.actorId);
  if (filter.entityType?.length) params.entityType = filter.entityType.join(',');
  if (filter.actionType?.length) params.actionType = filter.actionType.join(',');
  if (filter.tenantId) params.tenantId = String(filter.tenantId);
  if (filter.search) params.search = filter.search;
  if (filter.page) params.page = String(filter.page);
  if (filter.limit) params.limit = String(filter.limit);
  const qs = new URLSearchParams(params).toString();
  return qs ? `?${qs}` : '';
};

const list = (filter: AuditLogFilter) => http.get(`${API_ENDPOINTS.auditLog}${buildQuery(filter)}`);

const exportCsv = (filter: AuditLogFilter) =>
  http.get(`${API_ENDPOINTS.auditLogExport}${buildQuery(filter)}`, { responseType: 'blob' });

const AuditService = { list, exportCsv };

export default AuditService;
